var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14130",
    "data-name": "Group 14130",
    transform: "translate(-497 -6143)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70",
    "data-name": "Rectangle 70",
    width: 35,
    height: 34,
    rx: 17,
    transform: "translate(497 6143)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-copy",
    "data-name": "Icon feather-copy",
    transform: "translate(504.631 6149.631)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23578",
    "data-name": "Path 23578",
    d: "M14.965,13.5h6.594a1.465,1.465,0,0,1,1.465,1.465v6.594a1.465,1.465,0,0,1-1.465,1.465H14.965A1.465,1.465,0,0,1,13.5,21.559V14.965A1.465,1.465,0,0,1,14.965,13.5Z",
    transform: "translate(-5.372 -5.372)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23579",
    "data-name": "Path 23579",
    d: "M5.2,12.524H4.465A1.465,1.465,0,0,1,3,11.059V4.465A1.465,1.465,0,0,1,4.465,3h6.594a1.465,1.465,0,0,1,1.465,1.465V5.2",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.000be18a15ea8fbd37e989de6c6cbb58.svg";
export { ForwardRef as ReactComponent };